<template>
<div class="chapter">
<div class="inner_page">
<h1 class="left"><a id="page14"></a><a href="#/005toc#comesuddenly">Come Suddenly</a></h1>
<h3>(Malachi 3:1)</h3>
<p class="noindent">Come suddenly again, O Lord; Your temple waits for You today.</p>
<p class="noindent">Come in accordance to Your Word; come suddenly e’en while we pray.</p>
<p class="noindent">O blessed, blessed Holy Ghost, bring the revival we need most.<br/><br/></p>
<p class="noindent">Most graciously our hearts prepare for Your great work in this our day.</p>
<p class="noindent">Help each of us to do our share; remove each hind’rance from Your way.</p>
<p class="noindent">O Holy Ghost, our hearts inspire; descend in all Your holy fire.<br/><br/></p>
<p class="noindent">We need You more than we can tell; we need You more than we can say.</p>
<p class="noindent">Our worldliness and sin dispel; come, cleanse and fill us all, we pray.</p>
<p class="noindent">O Holy Ghost, come on us now as we in need before You bow.<br/><br/></p>
<p class="noindent">We pray, Lord, light the flame once more of Holy Ghost revival fire.</p>
<p class="noindent">Come now as in the days of yore; for You we wait with great desire.</p>
<p class="noindent">Come suddenly upon Your own and make Your holy presence known.<br/><br/></p>
<p class="noindent">Come suddenly and do much more than we can do in months and years.</p>
<p class="noindent">We plead Your mercy o’er and o’er; we praise You that revival nears!</p>
<p class="noindent">Come, Holy Ghost, descend today! Come suddenly on us, we pray.</p>
<p class="right">—Wesley L. Duewel</p>
<blockquote>
<p class="noindent">(Written in Moriah Chapel, Loughor, Gorseinon, South Wales, on September 24, 1964. I was kneeling in prayer with John and Henry Penry, converts in the first week of the 1904 revival under Evan Roberts. After hearing their testimonies of how God came then, Henry prayed, “Come suddenly again, O Lord.” I began the poem while he was still praying and while we were on our knees, and finished it after concluding with prayer myself. This is the same Moriah Chapel where the revival broke out. The Welsh sing this poem to the tune “Stella” in many hymnals.)</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007-comesuddenly.vue?c88e0e3e